import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  styled,
  Tooltip,
  tooltipClasses,
} from "@mui/material";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { toast } from "sonner";
import axiosInstance from "../../Axios.jsx";
import { SmartClassOpsTable } from "../../components/SmartClassOpsTable/SmartClassOpsTable.jsx";
import renderCellExpand from "../../components/rendercellexpand/renderCellExpand.jsx";
import TopWidgets from "../../components/topwidgets/TopWidgets";
import useAuth from "../../contexts/UserContext.tsx";
import "./home.scss";
import { useGlobalContext } from "../../contexts/GlobalContext.jsx";

const Home = () => {
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} placement="right" />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 14,
    },
  }));
  const [columns, setColumns] = useState([
    {
      field: "school_name",
      headerName: "School",
      flex: 3,
      minWidth: 400,
      renderCell: (params) => (
        <LightTooltip
          style={{ whiteSpace: "pre-wrap" }}
          title={`ID: ${params.row.school_id}, Type: ${params.row.school_type} District:${params.row.dist_name}`}
        >
          <Link
            className="text-[#8884d8] hover:underline"
            to={`/school/${params.row.school_id}`}
          >
            {renderCellExpand(params)}
          </Link>
        </LightTooltip>
      ),
    },
    {
      field: "center_cnt",
      headerName: "No of Centers",
      minWidth: 50,
      flex: 1,
    },
    {
      field: "teacher_cnt",
      headerName: "No of Teachers",
      minWidth: 10,
      flex: 1,
    },
    {
      field: "video_usage_cnt",
      headerName: "Video usage (mins)",
      minWidth: 40,
      flex: 1,
      renderHeader: (params) => {
        return (
          <div
            style={{
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
              lineHeight: "1.2",
            }}
          >
            {"Video usage\n(mins)"}
          </div>
        );
      },
    },
    {
      field: "excs_usage_cnt",
      headerName: "Exercise Usage",
      width: 10,
      flex: 1,
      renderHeader: (params) => {
        return (
          <div
            style={{
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
              lineHeight: "1.2",
            }}
          >
            {"Exercise usage\n(mins)"}
          </div>
        );
      },
    },
    {
      field: "hm_name",
      headerName: "HM name",
      // width: 150,
      flex: 2,
    },
    {
      field: "hm_phone",
      headerName: "HM Phone",
      width: 100,
      flex: 1,
    },
  ]);
  const quickFilterRef = React.useRef(null);
  const { user, logout } = useAuth();
  const [, setLoading] = useState(false);
  const [kpiData, setKpiData] = useState();
  const [smartClassData, setSmartClassData] = useState();
  const [smartClassOpsData, setSmartClassOpsData] = useState();
  useNavigate();
  const [selectedTimeframe, setSelectedTimeframe] = useState("cumulative");
  const [pageSize, setPageSize] = useState(25);
  const { setYearlySummaryData } = useGlobalContext();

  var school_types_array = user.view_access_list.school_types.split(",");
  //Remove the duplicate values from the array
  school_types_array = school_types_array
    .filter((value, index, self) => self.indexOf(value) === index)
    .map((schoolType) => schoolType.replace(/['"]+/g, ""))
    .sort();
  var district_array = user.view_access_list.district.split(",");
  //Remove the duplicate values from the array
  district_array = district_array
    .filter((value, index, self) => self.indexOf(value) === index)
    .map((district) => district.replace(/['"]+/g, ""))
    .sort();
  const [selectedSchoolTypes, setSelectedSchoolTypes] = useState(
    sessionStorage.getItem("H_lastSelectedSchoolTypes")
      ? JSON.parse(sessionStorage.getItem("H_lastSelectedSchoolTypes"))
      : school_types_array
  );
  const [selectedDistricts, setSelectedDistricts] = useState(
    sessionStorage.getItem("H_lastSelectedDistricts")
      ? JSON.parse(sessionStorage.getItem("H_lastSelectedDistricts"))
      : district_array
  );

  const handleTimeframeChange = (timeframe) => {
    if (timeframe === "cumulative") {
      setColumns([
        {
          field: "school_name",
          headerName: "School",
          flex: 3,
          minWidth: 400,
          renderCell: (params) => (
            <LightTooltip
              style={{ whiteSpace: "pre-wrap" }}
              title={`ID: ${params.row.school_id}, Type: ${params.row.school_type} District:${params.row.dist_name}`}
            >
              <Link
                className="text-[#8884d8] hover:underline"
                to={`/school/${params.row.school_id}`}
                onClick={() => {
                  setYearlySummaryData(params.row);
                }}
              >
                {renderCellExpand(params)}
              </Link>
            </LightTooltip>
          ),
        },
        {
          field: "center_cnt",
          headerName: "No of Centers",
          minWidth: 50,
          flex: 1,
        },
        {
          field: "teacher_cnt",
          headerName: "No of Teachers",
          minWidth: 10,
          flex: 1,
        },
        {
          field: "video_usage_cnt",
          headerName: "Video usage (mins)",
          minWidth: 40,
          flex: 1,
          renderHeader: (params) => {
            return (
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  lineHeight: "1.2",
                }}
              >
                {"Video usage\n(mins)"}
              </div>
            );
          },
        },
        {
          field: "excs_usage_cnt",
          headerName: "Exercise Usage",
          width: 10,
          flex: 1,
          renderHeader: (params) => {
            return (
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  lineHeight: "1.2",
                }}
              >
                {"Exercise usage\n(mins)"}
              </div>
            );
          },
        },
        {
          field: "hm_name",
          headerName: "HM name",
          // width: 150,
          flex: 2,
        },
        {
          field: "hm_phone",
          headerName: "HM Phone",
          width: 100,
          flex: 1,
        },
      ]);
    } else if (timeframe === "monthly") {
      setColumns([
        {
          field: "school_name",
          headerName: "School",
          flex: 3,
          minWidth: 400,
          renderCell: (params) => (
            <LightTooltip
              style={{ whiteSpace: "pre-wrap" }}
              title={`ID: ${params.row.school_id}, Type: ${params.row.school_type} District:${params.row.dist_name}`}
            >
              <Link
                className="text-[#8884d8] hover:underline"
                to={`/school/${params.row.school_id}`}
                onClick={() => {
                  setYearlySummaryData(params.row);
                }}
              >
                {renderCellExpand(params)}
              </Link>
            </LightTooltip>
          ),
        },
        {
          field: "center_cnt",
          headerName: "No of Centers",
          minWidth: 50,
          flex: 1,
        },
        {
          field: "teacher_cnt",
          headerName: "No of Teachers",
          minWidth: 10,
          flex: 1,
        },
        {
          field: "monthly_video_usage_cnt",
          headerName: "Video usage (mins)",
          minWidth: 40,
          flex: 1,
          renderHeader: (params) => {
            return (
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  lineHeight: "1.2",
                }}
              >
                {"Video usage\n(mins)"}
              </div>
            );
          },
        },
        {
          field: "monthly_excs_usage_cnt",
          headerName: "Exercise Usage",
          width: 10,
          flex: 1,
          renderHeader: (params) => {
            return (
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  lineHeight: "1.2",
                }}
              >
                {"Exercise usage\n(mins)"}
              </div>
            );
          },
        },
        {
          field: "hm_name",
          headerName: "HM name",
          // width: 150,
          flex: 2,
        },
        {
          field: "hm_phone",
          headerName: "HM Phone",
          width: 100,
          flex: 1,
        },
      ]);
    } else if (timeframe === "quaterly") {
      setColumns([
        {
          field: "school_name",
          headerName: "School",
          flex: 3,
          minWidth: 400,
          renderCell: (params) => (
            <LightTooltip
              style={{ whiteSpace: "pre-wrap" }}
              title={`ID: ${params.row.school_id}, Type: ${params.row.school_type} District:${params.row.dist_name}`}
            >
              <Link
                className="text-[#8884d8] hover:underline"
                to={`/school/${params.row.school_id}`}
                onClick={() => {
                  setYearlySummaryData(params.row);
                }}
              >
                {renderCellExpand(params)}
              </Link>
            </LightTooltip>
          ),
        },
        {
          field: "center_cnt",
          headerName: "No of Centers",
          minWidth: 50,
          flex: 1,
        },
        {
          field: "teacher_cnt",
          headerName: "No of Teachers",
          minWidth: 10,
          flex: 1,
        },
        {
          field: "quaterly_video_usage_cnt",
          headerName: "Video usage (mins)",
          minWidth: 40,
          flex: 1,
          renderHeader: (params) => {
            return (
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  lineHeight: "1.2",
                }}
              >
                {"Video usage\n(mins)"}
              </div>
            );
          },
        },
        {
          field: "quaterly_excs_usage_cnt",
          headerName: "Exercise Usage",
          width: 10,
          flex: 1,
          renderHeader: (params) => {
            return (
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  lineHeight: "1.2",
                }}
              >
                {"Exercise usage\n(mins)"}
              </div>
            );
          },
        },
        {
          field: "hm_name",
          headerName: "HM name",
          // width: 150,
          flex: 2,
        },
        {
          field: "hm_phone",
          headerName: "HM Phone",
          width: 100,
          flex: 1,
        },
      ]);
    } else if (timeframe === "yearly") {
      setColumns([
        {
          field: "school_name",
          headerName: "School",
          flex: 3,
          minWidth: 400,
          renderCell: (params) => (
            <LightTooltip
              style={{ whiteSpace: "pre-wrap" }}
              title={`ID: ${params.row.school_id}, Type: ${params.row.school_type} District:${params.row.dist_name}`}
            >
              <Link
                className="text-[#8884d8] hover:underline"
                to={`/school/${params.row.school_id}`}
                onClick={() => {
                  setYearlySummaryData(params.row);
                }}
              >
                {renderCellExpand(params)}
              </Link>
            </LightTooltip>
          ),
        },
        {
          field: "center_cnt",
          headerName: "No of Centers",
          minWidth: 50,
          flex: 1,
        },
        {
          field: "teacher_cnt",
          headerName: "No of Teachers",
          minWidth: 10,
          flex: 1,
        },
        {
          field: "yearly_video_usage_cnt",
          headerName: "Video usage (mins)",
          minWidth: 40,
          flex: 1,
          renderHeader: (params) => {
            return (
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  lineHeight: "1.2",
                }}
              >
                {"Video usage\n(mins)"}
              </div>
            );
          },
        },
        {
          field: "yearly_excs_usage_cnt",
          headerName: "Exercise Usage",
          width: 10,
          flex: 1,
          renderHeader: (params) => {
            return (
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  lineHeight: "1.2",
                }}
              >
                {"Exercise usage\n(mins)"}
              </div>
            );
          },
        },
        {
          field: "hm_name",
          headerName: "HM name",
          // width: 150,
          flex: 2,
        },
        {
          field: "hm_phone",
          headerName: "HM Phone",
          width: 100,
          flex: 1,
        },
      ]);
    }
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{ padding: 2, display: "flex", justifyContent: "space-between" }}
      >
        <GridToolbarQuickFilter inputRef={quickFilterRef} />
        <div className="flex gap-4">
          <select
            className="form-control w-[200px]"
            id="district"
            value={selectedTimeframe}
            onChange={(e) => {
              handleTimeframeChange(e.target.value);
              setSelectedTimeframe(e.target.value);
            }}
          >
            <option value="cumulative">Cumulative</option>
            <option value="monthly">Current month</option>
            <option value="quaterly">Last 3 months</option>
            <option value="yearly">Last year</option>
          </select>
          <div className="flex">
            <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
          </div>
        </div>
      </GridToolbarContainer>
    );
  }

  const [selectedSchoolString, setSelectedSchoolString] = useState(
    selectedSchoolTypes.map((word) => `'${word}'`).join(",")
  );
  const [selectedDistrictString, setSelectedDistrictString] = useState(
    selectedDistricts.map((word) => `'${word}'`).join(",")
  );

  const getSchoolSummaryListByDistrict = async () => {
    const school = selectedSchoolTypes.map((word) => `'${word}'`).join(",");
    const district = selectedDistricts.map((word) => `'${word}'`).join(",");
    try {
      const requests = [
        axiosInstance.post("/getSchoolSummaryListByDistrict", {
          user_id: user.user_id,
          auth_token: user.auth_token,
          school_types: school,
          district_names: district,
        }),
        axiosInstance.post("/getSchoolMonthlySummaryListByDistrict", {
          user_id: user.user_id,
          auth_token: user.auth_token,
          school_types: school,
          district_names: district,
        }),
        axiosInstance.post("/getSchoolYearlySummaryListByDistrict", {
          user_id: user.user_id,
          auth_token: user.auth_token,
          school_types: school,
          district_names: district,
        }),
      ];
      const [res1, res2, res3] = await Promise.all(requests);
      const monthlySummaryList = res2.data.data.school_monthly_summary_list;
      const yearlySummaryList = res3.data.data.school_yearly_summary_list;
      const formattedData = res1.data.data.school_summary_list.map((school) => {
        const { school_id } = school;
        const monthlyData = monthlySummaryList[school_id];
        const yearlyData = yearlySummaryList[school_id];

        return {
          ...school,
          center_cnt: isNaN(parseInt(school.center_cnt, 10))
            ? 0
            : parseInt(school.center_cnt, 10),
          teacher_cnt: isNaN(parseInt(school.teacher_cnt, 10))
            ? 0
            : parseInt(school.teacher_cnt, 10),
          video_usage_cnt: isNaN(parseInt(school.video_usage_cnt, 10))
            ? 0
            : parseInt(school.video_usage_cnt, 10),
          monthly_video_usage_cnt: monthlyData
            ? isNaN(
                parseInt(school.video_usage_cnt, 10) -
                  parseInt(monthlyData[3]?.video_count, 10)
              )
              ? 0
              : parseInt(school.video_usage_cnt, 10) -
                parseInt(monthlyData[3]?.video_count, 10)
            : 0,
          quaterly_video_usage_cnt: monthlyData
            ? isNaN(
                parseInt(school.video_usage_cnt, 10) -
                  parseInt(monthlyData[0]?.video_count, 10)
              )
              ? 0
              : parseInt(school.video_usage_cnt, 10) -
                parseInt(monthlyData[0]?.video_count, 10)
            : 0,
          yearly_video_usage_cnt: yearlyData
            ? isNaN(
                parseInt(school.video_usage_cnt, 10) -
                  parseInt(yearlyData[0].video_count, 10)
              )
              ? 0
              : parseInt(school.video_usage_cnt, 10) -
                parseInt(yearlyData[0].video_count, 10)
            : 0,
          excs_usage_cnt: isNaN(parseInt(school.excs_usage_cnt, 10))
            ? 0
            : parseInt(school.excs_usage_cnt, 10),
          monthly_excs_usage_cnt: monthlyData
            ? isNaN(
                parseInt(school.excs_usage_cnt, 10) -
                  parseInt(monthlyData[3]?.excs_count, 10)
              )
              ? 0
              : parseInt(school.excs_usage_cnt, 10) -
                parseInt(monthlyData[3]?.excs_count, 10)
            : 0,
          quaterly_excs_usage_cnt: monthlyData
            ? isNaN(
                parseInt(school.excs_usage_cnt, 10) -
                  parseInt(monthlyData[0]?.excs_count, 10)
              )
              ? 0
              : parseInt(school.excs_usage_cnt, 10) -
                parseInt(monthlyData[0]?.excs_count, 10)
            : 0,
          yearly_excs_usage_cnt: yearlyData
            ? isNaN(
                parseInt(school.excs_usage_cnt, 10) -
                  parseInt(yearlyData[0].excs_count, 10)
              )
              ? 0
              : parseInt(school.excs_usage_cnt, 10) -
                parseInt(yearlyData[0].excs_count, 10)
            : 0,
        };
      });
      return formattedData;
    } catch (err) {
      console.error(err.message);
      throw new Error(err.message);
    }
  };

  const getSmartClassOpsData = async (school, district) => {
    try {
      const res = await axiosInstance.post("/getSmartClassOpsStatus", {
        user_id: user.user_id,
        auth_token: user.auth_token,
        school_types: school,
        district_names: district,
        school_name: "",
      });

      setSmartClassOpsData(
        res.data.data.smartclass_ops_status.map((school) => ({
          ...school,
          center_id: parseInt(school.center_id),
        }))
      );
    } catch (err) {
      toast.error(err.message);
    }
  };
  const clickFilterHandler = async () => {
    sessionStorage.setItem(
      "H_lastSelectedSchoolTypes",
      JSON.stringify(selectedSchoolTypes)
    );
    sessionStorage.setItem(
      "H_lastSelectedDistricts",
      JSON.stringify(selectedDistricts)
    );
    const school_str = selectedSchoolTypes.map((word) => `'${word}'`).join(",");
    const district_str = selectedDistricts.map((word) => `'${word}'`).join(",");
    setSelectedSchoolString(school_str);
    setSelectedDistrictString(district_str);
    try {
      setLoading(true);
      const res = await axiosInstance.post("/getSchoolKPIByDistrict", {
        user_id: user.user_id,
        auth_token: user.auth_token,
        school_types: school_str,
        district_names: district_str,
      });
      if (res.data.data.message === "Invalid User") {
        toast.error("Invalid User");
        logout();
        return;
      }
      setKpiData(res.data.data.school_kpi);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
    getSmartClassOpsData(school_str, district_str);
  };

  const { data, error, isLoading } = useQuery({
    queryKey: [
      "schoolSummaryData",
      selectedSchoolString,
      selectedDistrictString,
    ],
    queryFn: getSchoolSummaryListByDistrict,
    retry: 1,
    staleTime: 5 * 60 * 1000, // Cache the data for 5 minutes
    keepPreviousData: true, // Keep previous data while fetching new data
  });

  useEffect(() => {
    if (data) {
      setSmartClassData(data);
    }
    if (error) {
      toast.error(error.message);
    }
  }, [data, error]);

  useEffect(() => {
    handleTimeframeChange(selectedTimeframe);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTimeframe]);

  useEffect(() => {
    clickFilterHandler();
    setYearlySummaryData(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    kpiData && (
      <div className="home flex flex-col">
        <div className="teacher-form-container flex gap-2 pt-2 mb-4">
          <FormControl fullWidth>
            <InputLabel id="checkbox-dropdown-label">School Types</InputLabel>
            <Select
              labelId="checkbox-dropdown-label"
              id="checkbox-dropdown"
              multiple
              label="School Types"
              value={selectedSchoolTypes}
              onChange={() => {}}
              renderValue={(selected) => [...selected].join(", ")}
            >
              <MenuItem
                key="select-all"
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedSchoolTypes(school_types_array);
                  } else {
                    setSelectedSchoolTypes([]);
                  }
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      indeterminate={
                        selectedSchoolTypes.length > 0 &&
                        selectedSchoolTypes.length < school_types_array.length
                      }
                      checked={
                        selectedSchoolTypes.length === school_types_array.length
                      }
                    />
                  }
                  label="Select All"
                />
              </MenuItem>
              {school_types_array.map((option) => (
                <MenuItem key={option} value={option}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedSchoolTypes.includes(option)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedSchoolTypes([
                              ...selectedSchoolTypes,
                              option,
                            ]);
                          } else {
                            setSelectedSchoolTypes(
                              selectedSchoolTypes.filter(
                                (type) => type !== option
                              )
                            );
                          }
                        }}
                      />
                    }
                    label={option}
                  />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel id="checkbox-dropdown-label">District</InputLabel>
            <Select
              labelId="checkbox-dropdown-label"
              id="checkbox-dropdown"
              multiple
              label="Districts"
              value={selectedDistricts}
              onChange={() => {}}
              renderValue={(selected) => [...selected].join(", ")}
            >
              <MenuItem
                key="select-all"
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedDistricts(district_array);
                  } else {
                    setSelectedDistricts([]);
                  }
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      indeterminate={
                        selectedDistricts.length > 0 &&
                        selectedDistricts.length < district_array.length
                      }
                      checked={
                        selectedDistricts.length === district_array.length
                      }
                    />
                  }
                  label="Select All"
                />
              </MenuItem>
              {district_array.map((option) => (
                <MenuItem key={option} value={option}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedDistricts.includes(option)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedDistricts([
                              ...selectedDistricts,
                              option,
                            ]);
                          } else {
                            setSelectedDistricts(
                              selectedDistricts.filter(
                                (type) => type !== option
                              )
                            );
                          }
                        }}
                      />
                    }
                    label={option}
                  />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <button
            onClick={clickFilterHandler}
            className="bg-blue-500 rounded-md hover:bg-blue-700 w-[250px] text-white"
          >
            Submit
          </button>
        </div>

        <TopWidgets data={kpiData} />
        {/* <div className="charts">
            <Featured
            title="Smart Class Activity"
            subtitle="Active Smart Classes today"
            description="Number of classes browsed videos or exercises today"
            percentage={40}
            score={300}
            lastMonth={344}
            lastWeek={340}
            />
            <div className='chartWrapper p-1'>
            <Chart
            title="Last 6 Months Smart Class usage"
            width="100%"
            height={360}
            data = {[
              { name: "January", Total: 1200 },
              { name: "February", Total: 2100 },
              { name: "March", Total: 800 },
              { name: "April", Total: 1600 },
              { name: "May", Total: 900 },
              { name: "June", Total: 1700 },
            ]}
            />
            </div>
          </div> */}
        {/* <TopUsersTable/> */}

        {isLoading && (
          <div className="flex justify-center items-center h-[50vh]">
            <PulseLoader color="#3B82F6" loading={isLoading} size={15} />
          </div>
        )}

        {smartClassData && !isLoading && (
          <DataGrid
            columns={columns}
            rows={smartClassData}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[25, 50, 100]}
            rowHeight={50}
            sx={{ marginTop: "2.5em" }}
            autoHeight={true}
            getRowId={(row) => row.school_id}
            components={{
              Toolbar: CustomToolbar,
            }}
            initialState={{
              filter: {
                filterModel: {
                  items: [
                    {
                      columnField: "school_name",
                      operatorValue: "contains",
                      value: "",
                    },
                  ],
                  quickFilterValues: [
                    sessionStorage.getItem("lastFilterNameHome"),
                  ],
                },
              },
            }}
            onFilterModelChange={(model) => {
              if (model.quickFilterValues.length > 0) {
                sessionStorage.setItem(
                  "lastFilterNameHome",
                  model.quickFilterValues.join(" ")
                );
              } else {
                sessionStorage.setItem("lastFilterNameHome", "");
              }
            }}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
          />
        )}

        {/* <div className="smart-class-usage-container shadow-md rounded-md p-4">
          <Typography
            sx={{
              fontWeight: "bold",
              textAlign: "center",
              marginTop: "30px",
              color: "GrayText",
            }}
            variant="h5"
          >
            Smart Class Usage Status
          </Typography>

          <div className="exercise-usage-graph-container">
            Exercise Usage Bar Chart Will be here
          </div>

          <div className="video-usage-graph-container">
            Video Usage Bar Chart Will be here
          </div>
        </div> */}

        {!isLoading && <SmartClassOpsTable data={smartClassOpsData} />}
        <div className="operation-status-container shadow-md rounded-md p-4 grid grid-cols-4">
          {/* <div className="operation-status-graph-container">
            <SmartClassOpsPieChart />
          </div> */}
        </div>
      </div>
    )
  );
};

export default Home;
